import {
  formatErrorWithRequestId,
  getRequestTransportErrorMessage,
  getSafeServerErrorMessage,
  readApiErrorEnvelope,
} from '#/utils/requestError';

export function getStocktakeApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'STOCKTAKE_DAILY_SERIAL_EXHAUSTED') {
    return data?.message || '當日盤點單號已用盡，請明日再試或聯繫管理員';
  }

  if (code === 'STOCKTAKE_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'STOCKTAKE_COMPARISON_PAYLOAD_INVALID') {
    const envelope = readApiErrorEnvelope(error);
    const message = envelope?.message || '盤點比對載入失敗';
    return formatErrorWithRequestId(message, envelope?.requestId);
  }

  const serverMessage = getSafeServerErrorMessage(error, fallback);
  if (serverMessage) {
    return serverMessage;
  }

  return data?.message || fallback;
}

export function isStocktakeVersionConflict(error) {
  return error?.response?.data?.code === 'STOCKTAKE_CONFLICT'
    || (
      error?.response?.status === 409
      && error?.response?.data?.code === 'STOCKTAKE_CONFLICT'
    );
}

export function isStocktakeDailySerialExhausted(error) {
  return error?.response?.data?.code === 'STOCKTAKE_DAILY_SERIAL_EXHAUSTED'
    || (
      error?.response?.status === 409
      && error?.response?.data?.code === 'STOCKTAKE_DAILY_SERIAL_EXHAUSTED'
    );
}
